import React from 'react';
import Crown from '../../assets/images/turbo-poker/crown.png';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';

export function Combinations({ t, showCardsImages, setShowCardsImages, winCombination }) {
  return (
    <div className='tp-mid-web-left'>
      <div className='tp-mid-web-left-inner'>
        <div className='combination-wrapper'>
          <div className='king-box'>
            <img src={Crown} alt='a' />
          </div>
          <div className='switch-box' onClick={() => setShowCardsImages((prev) => !prev)}>
            <i className='icon-tp-replace ' />
          </div>
          <div className='for-muv'>
            <div className='for-muv-cont '>
              {COMBINATIONS_PAYOUTS.map(({ winType, img, type, odd }) => (
                <div className='row-wrp cursor-default' key={winType}>
                  {/* add active class in win */}
                  <div className={`row-container ${winCombination === winType ? 'active' : ''}`}>
                    <div className='for-cards'>
                      {showCardsImages ? (
                        <div className='imag-block'>
                          <img className='cards-bl' alt='a' src={img} />
                        </div>
                      ) : (
                        <p className='comb-name'>{t(type)}</p>
                      )}
                    </div>
                    <div className='for-text'>
                      <p className='cof-text'>x{odd}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
